// services/api.ts - Serviço de API do Frontend

import axios, { AxiosError } from 'axios';
import { ResponseDinamica, InputProfessor } from '../types/index';

import { auth } from './firebase';

const API_BASE_URL = import.meta.env.PROD ? '' : (import.meta.env.VITE_API_URL || 'http://localhost:3001');

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000, // 2 minutos (geração pode demorar)
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para logging e autenticação
api.interceptors.request.use(
  async (config) => {
    // Adicionar token do Firebase se o usuário estiver logado
    const currentUser = auth.currentUser;
    if (currentUser) {
      try {
        const token = await currentUser.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Erro ao obter token fizebase:', error);
      }
    }
    
    console.log(`🚀 ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log(`✅ ${response.config.method?.toUpperCase()} ${response.config.url} - ${response.status}`);
    return response;
  },
  (error: AxiosError) => {
    console.error(`❌ ${error.config?.method?.toUpperCase()} ${error.config?.url} - ${error.response?.status || 'Network Error'}`);
    return Promise.reject(error);
  }
);

/**
 * Interface para opções disponíveis nos dropdowns
 */
export interface OpcoesDisponiveis {
  materias: string[];
  objetivos: string[];
  espacos: string[];
  necessidadesInclusao: string[];
  faixasEtarias: number[];
}

/**
 * Obtém as opções disponíveis para os dropdowns
 */
export const obterOpcoes = async (): Promise<OpcoesDisponiveis> => {
  const response = await api.get<OpcoesDisponiveis>('/api/public/options');
  return response.data;
};

/**
 * Gera uma nova dinâmica baseada nos inputs do professor
 */
export const gerarDinamica = async (input: InputProfessor): Promise<ResponseDinamica> => {
  const response = await api.post<ResponseDinamica>('/api/tools/dinamica/activities', input);
  return response.data;
};

/**
 * Health check do backend
 */
export const healthCheck = async (): Promise<boolean> => {
  try {
    const response = await api.get('/health');
    return response.status === 200;
  } catch (error) {
    return false;
  }
};

/**
 * Reporta um problema com conteúdo gerado
 */
export const reportarProblema = async (reporte: {
  geracaoId: string;
  email: string;
  descricao: string;
}): Promise<void> => {
  await api.post('/api/tools/dinamica/report-issue', {
    ...reporte,
    timestamp: new Date().toISOString()
  });
};

// Os erros chegam como vieram (AxiosError): a tela decide o texto pelo status (limite do dia, internet, falha).

export default api;
